<template>
  <VWidget
    :title="$t('Settings')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-spacer/>
      <v-switch
        v-model="item.exclusive"
        :label="$t('Exclusive')"
        class="mt-4"
      />
    </div>
    <div slot="widget-content">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
        >
          <v-select
            v-model="item.type"
            :error-messages="item.displayErrors('type')"
            :items="['catalog', 'coupon']"
            :label="$t('Discount type')"
            outline
          />
        </v-flex>
        <v-flex
          class="my-0 py-0"
          xs12
        >
          <v-select
            v-model="item.rate_type"
            :error-messages="item.displayErrors('rate_type')"
            :items="['fixed', 'percentage', 'distributed']"
            :label="$t('Rate type')"
            outline
          />
        </v-flex>
        <v-layout
          class="ml-0 my-0 py-0"
          xs12
        >
          <v-flex
            class="my-0 py-0"
            xs10
          >
            <v-select
              v-model="item.target"
              :error-messages="item.displayErrors('target')"
              :items="['shipping', 'items']"
              :label="$t('Discount Target')"
              outline
            />
          </v-flex>
          <v-flex class="pt-3">
            <v-tooltip
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  class="pointer"
                  color="primary"
                  dark
                  v-on="on"
                >
                  info
                </v-icon>
              </template>
              <span>
                {{ $t('Determines what kind of coupon it is') }}
              </span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-flex
          class="my-0 py-0"
          xs12
        >
          <v-text-field
            v-model="item.priority"
            :error-messages="item.displayErrors('priority')"
            :label="$t('Discount Priority')"
            persistent-hint
            outline
          />
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>

export default {
  name: 'DiscountSingleSettings',

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
